<template>
  <!-- @vue-skip TODO: 既存の型エラーを解消したら外す -->
  <div>
    <div v-if="!error">
      <div class="mb-x3" layout="row" layout-align="space-between-center">
        <el-button type="primary" @click="openCreateOrUpdateOrCopy('create')">
          <i class="mdi mdi-plus"> </i>落選ページの新規作成
        </el-button>
      </div>
      <div class="message message-info">
        一つの応募グループに対し、当選ページと落選ページは必ず一つずつ必要です。<br />複数の落選ページを作成すると、落選時にランダムで表示されます。
      </div>
      <div class="prize-table">
        <el-table
          class="mb-x2"
          :data="lotteryPages"
          stripe
          @header-click="headerClick"
          empty-text=" "
          style="width: 100%"
        >
          <el-table-column label="種別" min-width="8%">
            <template slot-scope="scope">
              <div class="label label-primary" type="primary" v-if="scope.row.lotteryType">当選</div>
              <div class="label label-default" v-if="!scope.row.lotteryType">落選</div>
            </template>
          </el-table-column>
          <el-table-column label="ページタイトル" sort-by="name" :render-header="renderHeader" min-width="20%">
            <template slot-scope="scope"> {{ scope.row.name }} </template>
          </el-table-column>
          <el-table-column min-width="8%">
            <template slot-scope="scope">
              <div layout layout-align="end">
                <el-tooltip class="ml-x1" :enterable="false" placement="top" content="編集">
                  <el-button
                    class="el-button--icon"
                    type="default"
                    @click="
                      openCreateOrUpdateOrCopy(scope.row.lotteryType === 1 ? 'edit_win' : 'edit_lose', scope.row.id)
                    "
                  >
                    <i class="mdi mdi-table-edit" />
                  </el-button>
                </el-tooltip>
                <el-tooltip :enterable="false" placement="top" content="複製">
                  <el-button
                    v-if="!scope.row.lotteryType"
                    class="el-button--icon"
                    type="default"
                    @click="openCreateOrUpdateOrCopy('copy', scope.row.id)"
                  >
                    <i class="mdi mdi-content-duplicate" />
                  </el-button>
                </el-tooltip>
                <a
                  v-if="!!scope.row.previewUrl"
                  :href="scope.row.previewUrl"
                  target="_blank"
                  @click="clickSnsConfirmEvent"
                >
                  <el-tooltip
                    class="ml-x1"
                    :enterable="false"
                    placement="top"
                    :content="scope.row.lotteryType ? '当選ページプレビュー' : '落選ページプレビュー'"
                  >
                    <el-button class="el-button--icon" type="default">
                      <img src="@/client/assets/images/twitter-web-instant-circle.svg" />
                    </el-button>
                  </el-tooltip>
                </a>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div layout layout-align="space-between-center">
          <Pagination
            type="当落ページ管理（X）"
            flex="1"
            :total="total"
            :pagingNo="params.pagingNo"
            :limitCount="params.limitCount"
            :onChangePagingNo="onChangePagingNo"
            :onChangeLimitCount="onChangeLimitCount"
          />
        </div>
      </div>
    </div>
    <el-card v-else>
      <div class="message message-error">
        データ取得に失敗しました。恐れ入りますが、時間を置いて再度お試しください。
      </div>
    </el-card>
  </div>
</template>
<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Pagination from '@/client/components/_atoms/pagination'
import Util from '@/client/core/util'
import { TrackingService } from '@/client/services'
import {
  GetLotteryPagesLotteryPagesResponse,
  useLotteryPageSettingDialogStore
} from '@/client/store/useLotteryPageSettingDialogStore'
import { API } from '@/client/utils/api'
import {
  WEB_INSTANTWIN_MEDIA_LOSE_ORIGIN_NAME,
  WEB_INSTANTWIN_MEDIA_LOSE_URL,
  WEB_INSTANTWIN_MEDIA_WIN_ORIGIN_NAME
} from '@/common/constants'

export default defineComponent({
  name: 'LotteryPageTable',
  components: {
    Pagination
  },
  computed: {
    ...mapState(useLotteryPageSettingDialogStore, ['lotteryPages', 'total', 'params', 'error', 'mode'])
  },

  methods: {
    ...mapActions(useLotteryPageSettingDialogStore, ['fetchLotteryPages', 'reset', 'setParams', 'setMode', 'setForm']),

    /**
     * ヘッダークリックイベント
     */
    headerClick(column: any) {
      TrackingService.sendEvent('sort:当落選ページの管理|タイトル')

      if (!column.sortBy) {
        return
      }

      const sort = this.getSortParameter(this.params.sort)

      if (column.sortBy.indexOf('-') === 0) {
        if (sort === column.sortBy) {
          this.onChangeSortBy('ASC')
        } else {
          this.onChangeSortBy('DESC')
        }
      } else {
        if (sort === column.sortBy) {
          this.onChangeSortBy('DESC')
        } else {
          this.onChangeSortBy('ASC')
        }
      }
    },

    /**
     * 当選の編集・落選の作成・編集・コピー用共通関数
     */
    async openCreateOrUpdateOrCopy(value: 'create' | 'copy' | 'edit_win' | 'edit_lose', id?: number) {
      if (!['create', 'copy', 'edit_win', 'edit_lose'].includes(value)) return

      const text = this.mode === 'edit_win' ? '当選' : '落選'

      if (value !== 'create') {
        if (!id) {
          return this.$notify({
            title: `${text}ページの取得に失敗しました。`,
            message: '恐れ入りますが、時間をおいて再度お試しください。',
            customClass: 'danger'
          })
        }

        TrackingService.sendEvent(`click:当落選ページの管理|${text}|${value === 'copy' ? '複製' : '編集'}`)
        await this.fetchLotteryPageById(value, id)
      } else {
        this.setForm({
          campaignId: this.params.campaignId,
          twCampaignPrizeId: this.params.prizeId,
          mediaUrl: WEB_INSTANTWIN_MEDIA_LOSE_URL,
          mediaOriginName: WEB_INSTANTWIN_MEDIA_LOSE_ORIGIN_NAME,
          lotteryType: 0,
          mediaType: 0,
          name: '',
          lotteryText: ''
        })

        TrackingService.sendEvent('click:当落選ページの管理|落選|新規作成')
      }

      this.setMode(value)
    },

    /**
     * 当落選ページの取得
     */
    async fetchLotteryPageById(mode: 'edit_win' | 'edit_lose' | 'copy', id?: number) {
      const response = (await API.get(`/twitter_lottery_pages/${id}`, {
        params: { campaignId: this.params.campaignId }
      })) as GetLotteryPagesLotteryPagesResponse

      if (!response.data || !response.data) {
        this.$notify({
          title: `${mode === 'edit_win' ? '当選' : '落選'}ページの取得に失敗しました。`,
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger'
        })

        return
      }

      this.setForm({
        campaignId: this.params.campaignId,
        twCampaignPrizeId: this.params.prizeId,
        twWebInstantwinLotteryPageSettingId: id,
        mediaUrl: response.data.mediaUrl,
        mediaOriginName:
          response.data.mediaOriginName && response.data.mediaOriginName.trim() !== ''
            ? response.data.mediaOriginName
            : mode === 'edit_win'
              ? WEB_INSTANTWIN_MEDIA_WIN_ORIGIN_NAME
              : WEB_INSTANTWIN_MEDIA_LOSE_ORIGIN_NAME,
        lotteryType: response.data.lotteryType,
        mediaType: response.data.mediaType,
        name: response.data.name,
        lotteryText: response.data.lotteryText ?? ''
      })
    },

    /**
     * ソート変更イベント
     */
    async onChangeSortBy(sort: 'ASC' | 'DESC') {
      this.setParams({ sort })
      await this.fetchLotteryPages()
    },

    /**
     * テーブルのヘッダーを描画
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(
        createElement,
        column.label,
        Util.getSortClass(this.getSortParameter(this.params.sort), this.getSortParameter(column.sortBy))
      )
    },

    /**
     * ソートパラメータを取得
     */
    getSortParameter(sort?: 'ASC' | 'DESC') {
      return sort === 'ASC' ? 'name' : '-name'
    },

    /**
     * ページを変更イベント
     */
    onChangePagingNo(page: number) {
      this.setParams({ pagingNo: page })
      this.fetchLotteryPages()
    },

    /**
     * 1ページあたりの表示件数変更イベント
     */
    onChangeLimitCount(limitCount: number) {
      this.setParams({ limitCount, pagingNo: 1 })
      this.fetchLotteryPages()
    },

    /**
     * Webプレビュー確認イベント
     */
    clickSnsConfirmEvent() {
      TrackingService.sendEvent('click:当落選ページの管理|Webプレビュー')
    }
  }
})
</script>
<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.label {
  display: inline-block;
  padding: 0 $spacing-unit;
  color: $text-color-white;
  border-radius: 5px;

  &.label-primary {
    background-color: $primary-color;
  }

  &.label-default {
    background-color: $disabled-color;
  }
}
</style>
